let map
let gymSource
let gymLayer

function initMap(gymId, gymLat, gymLong) {
	const gymIconStyle = new ol.style.Style({
		image: new ol.style.Icon({
			anchor: [0.5, 0.9],
			src: 'images/map-marker.png',
			crossOrigin: '',
			scale: [0.5, 0.5]
		})
	})

	gymSource = new ol.source.Vector({
		features: [new ol.Feature({
			geometry: new ol.geom.Point(ol.proj.fromLonLat([gymLat, gymLong])),
			name: 'name' + gymId
		})]
	})
	gymLayer = new ol.layer.Vector({
		source: gymSource,
		style: gymIconStyle
	})

	map = new ol.Map({
		target: 'map-' + gymId,
		layers: [
			new ol.layer.Tile({
				source: new ol.source.OSM()
			}),
			gymLayer
		],
		view: new ol.View({
			center: ol.proj.fromLonLat([gymLat, gymLong]),
			zoom: 17
		}),
		controls: [
			new ol.control.FullScreen(),
			new ol.control.Zoom()
		]
	})
}

$(function () {
	const page_contact = $('.page-contact')

	if (page_contact.length < 1) {
		return
	}

	initMap(1, 18.361250, 47.211042)
	initMap(2, 18.142762, 47.197061)
})
